{
  "inviteResultDialog": {
    "title": "招待結果",
    "text": "送信自体が失敗しました",
    "text2": "リクエストの検証に失敗しました。",
    "text3": "成功:",
    "text4": "件",
    "text5": "失敗:",
    "text6": "失敗したメールアドレス"
  },
  "userAreaCameraPopover": {
    "title": "{{userEmail}}の閲覧エリア/カメラ一覧"
  },
  "userEditDialog": {
    "email": "メールアドレス",
    "firstName": "氏名",
    "firstNameKana": "氏名 (カナ)",
    "roleId": "権限",
    "assignedSiteIds": "担当エリア",
    "permittedSiteIds": "エリア閲覧権限",
    "permittedCameraIds": "カメラ権限",
    "text": "ユーザー情報の更新に失敗しました",
    "text2": "このユーザーの編集権限がありません",
    "text3": "対象のユーザーが見つかりませんでした",
    "text4": "通信エラーが発生しました。しばらくしてから再度お試しください",
    "max": "50文字以下で入力してください",
    "max2": "名は50文字以下で入力してください",
    "katakana": "姓(カナ)にはカタカナのみ入力してください",
    "max3": "姓(カナ)は50文字以下で入力してください",
    "katakana2": "名(カナ)にはカタカナのみ入力してください",
    "max4": "名(カナ)は50文字以下で入力してください",
    "required": "メールアドレスを入力してください",
    "email2": "正しいメールアドレスを入力してください",
    "max5": "メールアドレスは255文字以下で入力してください",
    "enqueueSnackbar": "この権限 ({{originalNameEng}}) のユーザーは本画面で編集できません",
    "enqueueSnackbar2": "選択された権限が見つかりません",
    "enqueueSnackbar3": "ユーザー情報を更新しました",
    "title": "ユーザー編集",
    "text5": "読み込み中...",
    "text6": "更新中...",
    "label": "修正する",
    "title2": "更新内容を確認",
    "text7": "管理エリア・閲覧権限",
    "label2": "確認",
    "label3": "姓",
    "label4": "名",
    "label5": "セイ",
    "label6": "メイ",
    "text8": "メールアドレスの編集はアカウント設定から行なってください。",
    "text9": "メールアドレスの変更は本人のみ可能です。"
  },
  "userFilterBar": {
    "label": "すべて",
    "label2": "アクティブ",
    "label3": "招待中",
    "placeholder": "メールアドレスか名前で検索",
    "label4": "権限",
    "label5": "ステータス",
    "button": "ユーザー招待"
  },
  "userInviteDialog": {
    "enqueueSnackbar": "テナント情報を取得できませんでした",
    "enqueueSnackbar2": "選択された権限が見つかりません",
    "enqueueSnackbar3": "予期しないエラーが発生しました",
    "title": "ユーザーを招待",
    "text": "読み込み中...",
    "label": "招待",
    "label2": "修正する",
    "text2": "メールアドレス (",
    "text3": "件)",
    "text4": "権限",
    "text5": "管理エリア・閲覧権限",
    "label3": "確認",
    "label4": "メールアドレス"
  },
  "userTable": {
    "label": "ユーザー",
    "text": "{{name}}（招待中）",
    "label2": "閲覧エリア/カメラ",
    "text2": "エリア /",
    "text3": "カメラ",
    "label3": "権限"
  },
  "userTableHeader": {
    "text": "件"
  },
  "userViewLayout": {
    "text": "削除中...",
    "title": "ユーザーを削除",
    "text2": "この操作は元に戻せません。続行しますか？"
  },
  "useUserInviteForm": {
    "text": "メールアドレスを入力してください"
  },
  "useUserViewState": {
    "enqueueSnackbar": "ユーザーを削除しました",
    "text": "ユーザーの削除に失敗しました"
  },
  "user": {
    "title": "ユーザー管理"
  },
  "noPermissionWarning": {
    "text": "閲覧権限が設定されていません",
    "text2": "このまま",
    "text3": "するとカメラを閲覧できない状態になります。",
    "text4": "権限を設定する"
  },
  "permissionEditor": {
    "text": "担当エリア外の閲覧権限はこの画面では変更できません。"
  },
  "permissionHelp": {
    "text": "管理エリアのカメラは自動でアクセスできます。個別設定は不要です。",
    "text2": "管理エリア外は選択したカメラのみ閲覧できます。",
    "text3": "エリア単位の場合、後から追加されたカメラも自動で閲覧可能です。",
    "text4": "カメラ単位の場合、選択したカメラのみ閲覧可能です。後からエリアに追加されたカメラは自動では含まれません。"
  },
  "permissionTable": {
    "label": "閲覧",
    "label2": "管理",
    "ariaLabel": "{{name}} の管理権限",
    "ariaLabel2": "{{name}} の閲覧権限",
    "ariaLabel3": "{{areaName}} の管理権限",
    "ariaLabel4": "{{areaName}} の閲覧権限",
    "labelHeader": "エリア / カメラ"
  },
  "rolePicker": {
    "sv": "テナント内のすべてのエリア・カメラを管理できます",
    "areaManager": "割り当てられたエリアを管理し、カメラを閲覧できます",
    "viewer": "許可されたカメラの映像のみ閲覧できます",
    "label": "権限"
  },
  "svAutoAccessBanner": {
    "svMessage": "全体管理者はテナント内すべてのエリア・カメラに自動でアクセスできます。個別設定は不要です。"
  },
  "permissionBadgeStyles": {
    "label": "管理",
    "label2": "閲覧"
  },
  "summarizePermissions": {
    "text": "カメラなし",
    "text2": "{{totalCameras}}台すべて",
    "text3": "{{totalCameras}}台中{{selectedCount}}台"
  }
}
